module.exports = __webpack_public_path__ + "img/ct-btn-mail.028eab94.svg";